const priceTypeSwitcher = document.querySelector('.price-type')

priceTypeSwitcher?.addEventListener('click', togglePriceType)

function togglePriceType(e) {
    const target = e.target.closest('[name="price-type"]')

    if (!target) return

    const value = target.value

    document.querySelectorAll('._by-parts').forEach(el => {
        el.hidden = !(value === 'by-parts')
    })
    document.querySelectorAll('._full-price').forEach(el => {
        el.hidden = !(value === 'full-price')
    })
}
